import { render, staticRenderFns } from "./BlogListContent.vue?vue&type=template&id=47904fb8"
import script from "./BlogListContent.vue?vue&type=script&lang=js"
export * from "./BlogListContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports